import { Component } from "react";
import InputMask from "react-input-mask";
import {
  __EsPersonaJuridica,
  __MaximoCaracteresIdentificacion,
} from "../../../Utils/Funciones";
import ServicioComun from "../../../servicios/Comun";
import RegistroDeDatos from "./RegistroDeDatos";
import PersonaJuridica from "../Personas/PersonaJuridica";
import Identificacion from "../../../Contenedores/Comun/Identificacion";
import TipoPersona from "../../../Contenedores/Comun/TipoPersona";
import { CerrarNotificador, Notificar } from "../../Comunes/Notificador";
import ParametroConsultaPersona from "../../../Contenedores/Autorizaciones/ParametroConsultaPersona";
import ServicioAutorizaciones from "../../../servicios/Autorizaciones";
import TipoAutorizacion from "../../../Contenedores/Autorizaciones/TipoAutorizacion";
import PadronServicio from "../../../servicios/Padron";
import TipoPersonaDropdown from "../../Comunes/Dropdowns/TiposPersona/TipoPersonaDropdown";
import PageHeading from "../../Comunes/PageHeading";

export default class BusquedaPersona extends Component {
  constructor(props) {
    super(props);

    this.state = {
      MaxCaracteres: 9,
      MaxCaracteresPersonaFisica: 9,
      seleccionTipoPersona: "0",
      seleccionTipoPersonaFisica: "0",
      esBusquedaRepresentanteLegal: false,
      identificacion: "",
      identificacionPersonaFisica: "",
      mostrarRegistroDeDatos: false,
      MostrarBusquedaPersona: false,
      MostrarInformacionJuridica: false,
      datosPersonaJuridica: [],
      datosRepresentanteLegal: [],
      DatosDeBusquedaPersona: [],
      EsPersonaFisica: false,
      seleccionTipoAutorizacion: "3",
      ListaTiposAutorizacion: [],
    };
    this._ConsultarInformacionPersona =
      this._ConsultarInformacionPersona.bind(this);
    this._ConsultarRepresentanteLegal =
      this._ConsultarRepresentanteLegal.bind(this);
    this._onSeleccionTipoPersona = this._onSeleccionTipoPersona.bind(this);
    this._onSeleccionTipoPersonaFisica =
      this._onSeleccionTipoPersonaFisica.bind(this);
    this._ObtengaIdentificacion = this._ObtengaIdentificacion.bind(this);
    this._ObtengaIdentificacionPersonaFisica =
      this._ObtengaIdentificacionPersonaFisica.bind(this);
    this._onSeleccionTipoAutorizacion =
      this._onSeleccionTipoAutorizacion.bind(this);
  }

  async componentDidMount() {
    await this.obtengaCombobox();
  }

  async obtengaCombobox() {
    let listaTiposAutorizacion = await ServicioComun.ObtengaTiposAutorizacion();

    this.setState({
      ListaTiposAutorizacion: listaTiposAutorizacion,
      MostrarBusquedaPersona: true,
    });
  }

  cargarParametrosBusquedaPersona() {
    let parametro = new ParametroConsultaPersona();
    parametro.Identificacion = new Identificacion();
    parametro.Identificacion.Codigo =
      this.state.identificacion === "" ? null : this.state.identificacion;
    parametro.Identificacion.TipoPersona = new TipoPersona();
    parametro.Identificacion.TipoPersona.Codigo =
      this.state.seleccionTipoPersona === "0"
        ? null
        : this.state.seleccionTipoPersona;
    parametro.TipoAutorizacion = new TipoAutorizacion();
    parametro.TipoAutorizacion.Codigo = this.state.seleccionTipoAutorizacion;

    return parametro;
  }

  cargarParametrosBusquedaRepresentanteLegal() {
    let parametro = new Identificacion();
    parametro.Codigo =
      this.state.identificacionPersonaFisica === ""
        ? null
        : this.state.identificacionPersonaFisica;
    parametro.TipoPersona = new TipoPersona();
    parametro.TipoPersona.Codigo =
      this.state.seleccionTipoPersonaFisica === "0"
        ? null
        : this.state.seleccionTipoPersonaFisica;
    return parametro;
  }

  async _ConsultarInformacionPersona() {
    let NoesPersonaJuridica = await __EsPersonaJuridica(
      this.state.seleccionTipoPersona
    );
    let parametro = this.cargarParametrosBusquedaPersona();
    CerrarNotificador();
    if (!NoesPersonaJuridica) {
      await this.CargarInformacionPersonaJuridica(parametro);
    } else {
      await this.BuscarPersonaFisica(parametro);
    }
  }

  async BuscarPersonaFisica(parametro) {
    let personaFisica =
      await ServicioAutorizaciones.ConsultarPersonaParaAutorizacion(parametro);
    if (personaFisica.esValido) {
      this.setState({
        esBusquedaRepresentanteLegal: false,
        mostrarRegistroDeDatos: true,
        MostrarBusquedaPersona: false,
        MostrarInformacionJuridica: false,
        DatosDeBusquedaPersona: personaFisica,
        datosPersonaJuridica: null,
        EsPersonaFisica: true,
      });
    } else {
      Notificar("error", personaFisica.errores);
    }
  }

  async _ConsultarRepresentanteLegal() {
    let representanteLegal = this.cargarParametrosBusquedaRepresentanteLegal();
    let Consultapersona = await PadronServicio.ObtengaPersonaUnificada(
      representanteLegal
    );

    if (Consultapersona.esValido) {
      this.setState({
        esBusquedaRepresentanteLegal: false,
        mostrarRegistroDeDatos: true,
        MostrarBusquedaPersona: false,
        MostrarInformacionJuridica: false,
        datosRepresentanteLegal: Consultapersona,
        EsPersonaFisica: false,
      });
    } else {
      Notificar("error", Consultapersona.errores);
    }
  }

  async CargarInformacionPersonaJuridica(parametro) {
    let Consultapersona =
      await ServicioAutorizaciones.ConsultarPersonaParaAutorizacion(parametro);

    if (Consultapersona.esValido) {
      this.setState({
        esBusquedaRepresentanteLegal: true,
        mostrarRegistroDeDatos: false,
        MostrarInformacionJuridica: true,
        datosPersonaJuridica: Consultapersona,
        seleccionTipoPersonaFisica: "0",
        identificacionPersonaFisica: "",
      });
    } else {
      Notificar("error", Consultapersona.errores);
    }
  }

  async _ObtengaIdentificacion({ target: { value } }) {
    this.setState({
      identificacion: value,
    });
  }

  async _ObtengaIdentificacionPersonaFisica({ target: { value } }) {
    this.setState({
      identificacionPersonaFisica: value,
    });
  }

  async _onSeleccionTipoPersona(e) {
    let valor = e.target.value;
    let max = await __MaximoCaracteresIdentificacion(valor);
    this.setState({
      MaxCaracteres: max,
      seleccionTipoPersona: valor,
    });
  }

  async _onSeleccionTipoPersonaFisica(e) {
    let valor = e.target.value;
    let max = await __MaximoCaracteresIdentificacion(valor);
    this.setState({
      MaxCaracteresPersonaFisica: max,
      seleccionTipoPersonaFisica: valor,
    });
  }

  async maskIdentificacion(v) {
    let digitos = !v ? "" : v.replace(/[^\d]/g, "");
    if (digitos.length > this.state.MaxCaracteres) {
      digitos = v.substring(0, this.state.MaxCaracteres);
      this.setState({ identificacion: digitos });
    }
    return digitos;
  }

  async maskIdentificacionPersonaFisica(v) {
    let digitos = !v ? "" : v.replace(/[^\d]/g, "");
    if (digitos.length > this.state.MaxCaracteresPersonaFisica) {
      digitos = v.substring(0, this.state.MaxCaracteresPersonaFisica);
      this.setState({ identificacionPersonaFisica: digitos });
    }
    return digitos;
  }

  async _onSeleccionTipoAutorizacion(e) {
    this.setState({
      seleccionTipoAutorizacion: e.target.value,
    });
  }

  VolverABusquedaPersona(success) {
    if (success.length > 0) this.VolverAEstadoBusquedaNuevo(success);
    else {
      this.setState({
        esBusquedaRepresentanteLegal: false,
        mostrarRegistroDeDatos: false,
        MostrarInformacionJuridica: false,
        MostrarBusquedaPersona: true,
      });
    }
  }

  VolverAEstadoBusquedaNuevo(success) {
    this.setState({
      esBusquedaRepresentanteLegal: false,
      mostrarRegistroDeDatos: false,
      MostrarInformacionJuridica: false,
      MostrarBusquedaPersona: true,
      seleccionTipoAutorizacion: "3",
      seleccionTipoPersona: "0",
      seleccionTipoPersonaFisica: "0",
      identificacion: "",
      identificacionPersonaFisica: "",
    });
    Notificar("success", success);
  }

  render() {
    return (
      <div>
        {this.state.MostrarBusquedaPersona ? (
          <>
            <PageHeading title="Incluir Nueva Autorización" />
            <div id="contenedorParametrosInclusionAutorizacion">
              <div className="card shadow mb-4">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card mb-4">
                        <div className="card-header">
                          <h6 className="m-0 font-weight-bold text-primary">
                            Datos de la Autorización
                          </h6>
                        </div>
                        <div className="card-body">
                          <div className="form-group row">
                            <div className="col-md-3 col-form-label">
                              <label htmlFor="IdTipoAutorizacion">
                                Tipo Autorización
                              </label>
                            </div>
                            <div className="col-md-9">
                              <select
                                id="IdTipoAutorizacion"
                                className="form-control"
                                value={this.state.seleccionTipoAutorizacion}
                                onChange={(e) =>
                                  this._onSeleccionTipoAutorizacion(e)
                                }
                              >
                                {this.state.ListaTiposAutorizacion.map(
                                  (item) => (
                                    <option
                                      key={item.descripcion}
                                      value={item.codigo}
                                    >
                                      {item.descripcion}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-md-3 col-form-label">
                              <label htmlFor="TipoPersona"> Tipo Persona</label>
                            </div>
                            <div className="col-md-9">
                              <TipoPersonaDropdown
                                id="TipoPersona"
                                className="form-control"
                                value={this.state.seleccionTipoPersona}
                                onChange={(e) =>
                                  this._onSeleccionTipoPersona(e)
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group row ">
                            <div className="col-md-3 col-form-label">
                              <label htmlFor="IdentificacionID">
                                {" "}
                                Identificación
                              </label>
                            </div>
                            <div className="col-md-9">
                              <InputMask
                                mask={this.maskIdentificacion(
                                  this.state.identificacion
                                )}
                                maskChar=""
                                placeholder="Identificación"
                                value={this.state.identificacion}
                                id="IdentificacionID"
                                className="form-control"
                                onChange={this._ObtengaIdentificacion}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <button
                        onClick={() => this._ConsultarInformacionPersona()}
                        type="button"
                        className="btn btn-primary btn-icon-split"
                      >
                        <span className="icon text-white-50">
                          <i className="fas fa-search"></i>
                        </span>
                        <span className="text">Buscar</span>
                      </button>
                    </div>

                    {this.state.esBusquedaRepresentanteLegal &&
                    this.state.MostrarBusquedaPersona ? (
                      <div className="col-md-6" id="divBusquedaRepLegal">
                        <div className="card mb-4">
                          <div className="card-header">
                            <h6 className="m-0 font-weight-bold text-primary">
                              Búsqueda Representante Legal
                            </h6>
                          </div>
                          <div className="card-body">
                            <div className="form-group row">
                              <div className="col-md-4 col-form-label">
                                <label htmlFor="IdTipoPersonaRepLegal">
                                  {" "}
                                  Tipo Persona
                                </label>
                              </div>
                              <div className="col-md-8">
                                <TipoPersonaDropdown
                                  id="IdTipoPersonaRepLegal"
                                  className="form-control"
                                  value={this.state.seleccionTipoPersonaFisica}
                                  clasePersona="F"
                                  onChange={(e) =>
                                    this._onSeleccionTipoPersonaFisica(e)
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group row ">
                              <div className="col-md-4 col-form-label">
                                <label htmlFor="IdentificacionRepLegal">
                                  {" "}
                                  Representante Legal
                                </label>
                              </div>
                              <div className="col-md-8">
                                <InputMask
                                  mask={this.maskIdentificacionPersonaFisica(
                                    this.state.identificacionPersonaFisica
                                  )}
                                  maskChar=""
                                  placeholder="Identificación"
                                  value={this.state.identificacionPersonaFisica}
                                  id="IdentificacionRepLegal"
                                  className="form-control"
                                  onChange={
                                    this._ObtengaIdentificacionPersonaFisica
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <button
                          onClick={() => this._ConsultarRepresentanteLegal()}
                          type="button"
                          className="btn btn-primary btn-icon-split text-lg-right"
                        >
                          <span className="icon text-white-50">
                            <i className="fas fa-search"></i>
                          </span>
                          <span className="text">Buscar</span>
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}

        <div>
          {this.state.MostrarInformacionJuridica ? (
            <PersonaJuridica
              PersonaJuridica={this.state.datosPersonaJuridica}
            />
          ) : null}
        </div>

        <div>
          {this.state.mostrarRegistroDeDatos ? (
            <RegistroDeDatos
              DatosDeBusquedaPersona={this.state.DatosDeBusquedaPersona}
              DatosPersonaJuridica={this.state.datosPersonaJuridica}
              datosRepresentanteLegal={this.state.datosRepresentanteLegal}
              EsPersonaFisica={this.state.EsPersonaFisica}
              TipoAutorizacion={this.state.seleccionTipoAutorizacion}
              VolverABusquedaPersona={this.VolverABusquedaPersona.bind(this)}
            />
          ) : null}
        </div>
      </div>
    );
  }
}
